// extracted by mini-css-extract-plugin
export default {"root":"Status_root__d8DFT","state0":"Status_state0__cBghT","state1":"Status_state1__Gdhug","state2":"Status_state2__moKv8"};